module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('img', {
    staticClass: "mint-image",
    style: (_vm.computeStyle),
    attrs: {
      "watermark": _vm.watermark,
      "src": _vm.src
    },
    on: {
      "click": _vm.handleClick
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24fdac3d","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/image/src/image.vue
// module id = 374
// module chunks = 0